import {Box, SxProps, Theme, Typography} from "@mui/material";
import {ReactNode} from "react";

interface BoxWithLabelProps {
    label?: string;
    children: ReactNode;
    borderColor?: string;
    borderRadius?: number;
    sx?: SxProps<Theme>;
}

const BoxWithLabel: React.FC<BoxWithLabelProps> = ({
                                                       label,
                                                       children,
                                                       borderColor = 'grey.400',
                                                       borderRadius = 2,
                                                       sx = {},
                                                   }) => {
    return (
        <Box
            border={1}
            borderColor={borderColor}
            borderRadius={borderRadius}
            p={2}
            mb={2}
            sx={sx}
        >
            {label && (
                <Typography variant="h6" gutterBottom>
                    {label}
                </Typography>
            )}
            {children}
        </Box>
    );
};

export default BoxWithLabel;
